import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t">
      <div className="container py-8 space-y-6">
        {/* 링크 */}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
          <Link to="/terms" className="hover:underline">이용약관</Link>
          <span className="text-muted-foreground/30">|</span>
          <Link to="/privacy" className="hover:underline font-medium text-foreground">개인정보처리방침</Link>
          <span className="text-muted-foreground/30">|</span>
          <Link to="/refund-policy" className="hover:underline">환불 정책</Link>
          <span className="text-muted-foreground/30">|</span>
          <Link to="/contact" className="hover:underline">문의하기</Link>
        </div>

        {/* 회사 정보 — 모바일: 세로 배치, 데스크톱: 가로 배치 */}
        <div
          data-testid="footer-company-info"
          className="flex flex-col md:flex-row md:flex-wrap md:gap-x-2 gap-y-1 text-xs sm:text-sm text-muted-foreground/80 leading-relaxed"
        >
          <span className="font-medium text-foreground/80">(주)리얼드로우</span>
          <span>대표자 최상규</span>
          <span>사업자등록번호 852-86-03310</span>
          <span>통신판매업 신고번호 제2026-서울마포-1087호</span>
          <span>서울특별시 마포구 마포대로 122 17층</span>
          <span>고객센터 070-8095-3833</span>
          <a href="mailto:support@scpnovel.com" className="hover:underline">
            support@scpnovel.com
          </a>
        </div>

        {/* 저작권 및 라이선스 */}
        <div className="border-t pt-4 flex flex-col gap-2 text-xs text-muted-foreground/70 md:flex-row md:items-center md:justify-between">
          <p>© 2026 (주)리얼드로우. All rights reserved.</p>
          <p>
            SCP 콘텐츠는{' '}
            <a
              href="https://creativecommons.org/licenses/by-sa/3.0/deed.ko"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-foreground"
            >
              CC BY-SA 3.0
            </a>
            {' '}라이선스를 따릅니다.
          </p>
        </div>
      </div>
    </footer>
  );
}
